module.exports = __webpack_public_path__ + "static/media/php-beginner.5eadedcc.png";